<template>
  <div class="v-modal" :class="{show}" @click="$attrs.closable==null||close()">
    <transition name="v-modal-body">
      <div class="v-modal-body" :style="style" v-if="show" @click.stop>
        <slot/>
      </div>
    </transition>
  </div>
</template>

<script>
let modals = document.querySelector("body>.v-modals");
export default {
  props: {
    width: {
      default: ""
    },
    height: {
      default: ""
    }
  },
  data() {
    return {
      show: false
    };
  },
  computed: {
    style() {
      return {
        width: this.$filter.unit(this.width, "px"),
        height: this.$filter.unit(this.height, "px")
      };
    }
  },
  methods: {
    open() {
      modals.appendChild(this.$el).parentNode.classList.add("v-modals");
      this.$timeout(() => (this.show = true), 100);
    },
    close() {
      this.show = false;
      this.$timeout(() => modals.removeChild(this.$el), 300);
    }
  },
  mounted() {
    modals = modals || document.body.appendChild(document.createElement("div"));
  },
  destroyed() {
    this.show && modals.removeChild(this.$el);
  }
};
</script>

<style lang="less">
.v-modals {
  left: 0px;
  right: 0px;
  height: 0px;
  display: flex;
  position: fixed;
  align-items: center;
  flex-direction: column;
  > .v-modal {
    opacity: 0;
    padding: 50px;
    position: fixed;
    visibility: hidden;
    transition: 300ms;
    &.show {
      opacity: 1;
      visibility: visible;
    }
    &[mask] {
      top: 0px;
      left: 0px;
      right: 0px;
      bottom: 0px;
      display: flex;
      position: fixed;
      overflow-y: scroll;
      align-items: center;
      padding-bottom: 0px;
      flex-direction: column;
      transform: translate3d(0, 0, 0);
      background-color: rgba(0, 0, 0, 0.2);
      > .v-modal-body {
        position: absolute;
        margin-bottom: 50px;
        max-width: calc(100% - 100px);
        transform: translate3d(0, 0px, 0);
      }
      > .v-modal-body-enter,
      > .v-modal-body-leave-to {
        transform: translate3d(0, -50px, 0);
      }
    }
    > .v-modal-body {
      margin: auto;
      border-radius: 4px;
      box-sizing: border-box;
      background-color: #ffffff;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
      transition: 300ms;
    }
    > .v-modal-body-enter,
    > .v-modal-body-leave-to {
      transform: translate3d(0, -50px, 0);
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/vue-ext/components/modal/index.vue